import { createAction, props } from '@ngrx/store';
import { KeyValuePair } from '@shared/models';
import { FeatureToggle } from '@store/reducers/feature/feature.reducer';

export const EnableFeatureToggles = createAction(
  '[Feature] Enable Toggles',
  props<{ payload: string[] }>(),
);
export const UpdateFeatureToggleValue = createAction(
  '[Feature] Set Feature Toggle Value',
  props<{ payload: KeyValuePair<FeatureToggle, boolean> }>(),
);
export const GetAndSetAllFeatureToggles = createAction('[Feature] Get And Set All Feature Toggles');
